module.exports = __webpack_public_path__ + "img/success-dhm.876a40af.png";